<app-sales-final-message-kredicash-v3
  *ngIf="isFlowKrdya"
  [message]="message"
  (nextStepEvent)="onNextStep()"
  (gotoStepEvent)="onGotoStep($event)">
</app-sales-final-message-kredicash-v3>

<app-sales-final-message-kredicash-v2
  *ngIf="!isFlowKrdya"
  [message]="message"
  (nextStepEvent)="onNextStep()"
  (gotoStepEvent)="onGotoStep($event)">
</app-sales-final-message-kredicash-v2>
